import type { MindstringPrototype } from "@/generated/fastapi";
import { PROTOTYPE_TONES } from "@/shared/config/prototypeTheme";
import type { StudioPrototypeTone } from "./studioChrome.types";

export const SEGMENT_LABEL_PROPS = {
  fontSize: "xs",
  fontWeight: "semibold",
  color: "moveon.text.muted",
} as const;

export const PROTOTYPE_FRAME_TONES: Record<
  MindstringPrototype,
  StudioPrototypeTone
> = PROTOTYPE_TONES;
